import React, { useEffect, useState } from "react";

import "../../css/GenericModal.css";

const GenericModal = ({ isOpen, onClose, children }) => {
  const [visible, setVisible] = useState(isOpen);
  const [closing, setClosing] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setVisible(true);
      setClosing(false);
    } else if (visible) {
      // 開始關閉動畫
      setClosing(true);
    }
  }, [isOpen]);

  const handleAnimationEnd = () => {
    if (closing) {
      setVisible(false);
      setClosing(false);
    }
  };

  if (!visible) return null;

  return (
    <div
      className="generic-modal-backdrop"
      onClick={onClose}
    >
      <div
        className={`generic-modal ${closing ? "closing" : ""}`}
        onClick={e => e.stopPropagation()}
        onAnimationEnd={handleAnimationEnd}
      >
        {children}
      </div>
    </div>
  );
};

export { GenericModal };
